export default {
  hierarchy: {
    title: "Filtrar por jerarquía de productos",
    clear: "Quitar filtro",
    kind_atc: "ATC",
    kind_ah: "Agrupación homogénea",
    kind_spr: "Conjunto SPR",
    kind_pa: "Principio activo",
    kind_lab: "Laboratorio titular",
    kind_nregistro: "Nº de registro",
    placeholder_atc: "p. ej. C09CA",
    placeholder_ah: "código o nombre de la AH",
    placeholder_spr: "p. ej. F206",
    placeholder_pa: "p. ej. Olmesartán",
    placeholder_lab: "p. ej. Daiichi Sankyo",
    placeholder_nregistro: "p. ej. 75012",
  },
};
